import { KnowledgeService } from '@kizen/api/knowledge';
import AxiosService from './AxiosService';

const instance = new KnowledgeService(AxiosService);
Object.freeze(instance);

export default instance;
